import { combineEpics, Epic, ofType } from "redux-observable";
import { Observable, timer } from "rxjs";
import { map, mapTo, switchMap } from "rxjs/operators";
import { NotificationActions } from "./actions";

const processNotification: Epic<NotificationActions.Actions> = (action$) =>
  action$.pipe(
    ofType(NotificationActions.ActionTypes.setNotification),
    switchMap<NotificationActions.Actions, Observable<void>>(() =>
      timer(15000).pipe(mapTo(undefined))
    ),
    map(NotificationActions.clearNotification)
  );
export const notificationEpic = combineEpics(processNotification);
